import { BaseWidgetRenderer } from './base-widget-renderer';
import { SubmitWidgetRenderer } from './submit-widget-renderer';
import { TextWidgetRenderer } from './text-widget-renderer';
import { HeaderWidgetRenderer } from './header-widget-renderer';
import { DividerWidgetRenderer } from './divider-widget-renderer';
import { ImageWidgetRenderer } from './image-widget-renderer';
import { SpacerWidgetRenderer } from './spacer-widget-renderer';
import { SignInWidgetRenderer } from './signin-widget-renderer';
import { SignUpWidgetRenderer } from './signup-widget-renderer';
import { ForgotPasswordWidgetRenderer } from './forgot-password-widget-renderer';
import { NavButtonWidgetRenderer } from './nav-button-widget-renderer';
import { WidgetJsonData } from '../../models/element-types';

export class WidgetRendererFactory {
    private renderers = new Map<string, BaseWidgetRenderer<WidgetJsonData>>(
        [
            ['submit', new SubmitWidgetRenderer()],
            ['text', new TextWidgetRenderer()],
            ['header', new HeaderWidgetRenderer()],
            ['divider', new DividerWidgetRenderer()],
            ['image', new ImageWidgetRenderer()],
            ['spacer', new SpacerWidgetRenderer()],
            ['signin', new SignInWidgetRenderer()],
            ['signup', new SignUpWidgetRenderer()],
            ['forgotpassword', new ForgotPasswordWidgetRenderer()],
            ['navbutton', new NavButtonWidgetRenderer()]
        ]
    );

    public getRenderer(widgetType: string): BaseWidgetRenderer<WidgetJsonData> {
        const renderer = this.renderers.get(widgetType.toLowerCase());
        if (!renderer) {
            throw new Error(`No renderer registered for widget type: ${widgetType}`);
        }

        return renderer;
    }
}
